import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MtcCoreService } from './mtc-core.service';
import { MtcSelectorComponent } from './mtc-selector/mtc-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [MtcSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [MtcCoreService],
  exports: [MtcSelectorComponent],
})
export class MtcCoreModule {}
